import { inboundApiInstance, legacyApiInstance } from "./axiosInstance";
import { InboundItem } from "../../types/item";

export const createItem = async (token: string, params: InboundItem) => {
    const response = await inboundApiInstance.post("/Item", params, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  
    return response;
  };

  export const editItem = async (token: string, params: InboundItem) => {
    const response = await inboundApiInstance.post(`/Item/update/${params.id}`, params, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  };

  export const deleteItem = async (token: string, params: {itemId: number}) => {
    const response = await inboundApiInstance.delete(`/Item/${params.itemId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  
    return response;
  };

  export const fetchItems = async (token: string, params: {isPaginated: boolean}) => {
    const response = await inboundApiInstance.get("/Item/inbound", {
      params: params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  
    return response;
  };



  export const attachItemToMedia = async (token: string, params: {itemId: number, fileUrl: string}) => {
    const response = await inboundApiInstance.post(`/Item/${params.itemId}/media`, { fileUrl: params.fileUrl }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  };

  export const searchAllAccounts = async (token: string, params: {searchString: string}) => {
    const response = await inboundApiInstance.get(`/account/SearchAccounts?searchString=${params.searchString}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  };

  export const getAccountPackagesandLocations = async (token: string, params: {accountId: number}) => {
    const response = await legacyApiInstance.get(`/package/getAllForAccount?account_ID=${params.accountId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  };

  export const deleteMediaFromServer = async (token: string, params: {itemId: number, mediaUrl: string}) => {
    const response = await inboundApiInstance.delete(`/Item/media?url=${params.mediaUrl}&itemId=${params.itemId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });
    return response;
  };

  export const getHouseLocationsAPI = async (token: string) => {
    const response = await inboundApiInstance.get(`/location/house`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });
    return response;
  };

  export const getEventsAPI = async (token: string) => {
    const response = await legacyApiInstance.get(`/Events`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });
    return response;
  };

  


  